import {EventEmitter, signal} from '@angular/core';

import {TaskViewModel} from '../view-models/task.view-model';
import {TaskStepDetailViewModel} from '../view-models/task-step-detail.view-model';
import {TaskStepStateViewModel} from '../view-models/task-step-state.view-model';
import {TaskStepUpdateDto} from '@dto/tasks/task-step-update.dto';

export abstract class BaseTaskComponent {
  public readonly previousClicked: EventEmitter<void> = new EventEmitter();
  public readonly nextClicked: EventEmitter<void> = new EventEmitter();
  public readonly closeClicked: EventEmitter<void> = new EventEmitter();
  public readonly taskUpdated = new EventEmitter<TaskStepUpdateDto>();
  public readonly processingUpdated = new EventEmitter<boolean>();

  public readonly task = signal<TaskViewModel>(undefined!);
  public readonly step = signal<TaskStepDetailViewModel>(undefined!);
  public readonly state = signal<TaskStepStateViewModel>(undefined!);
  private processingFlag = false;

  public initialize(task: TaskViewModel,
                    step: TaskStepDetailViewModel,
                    state: TaskStepStateViewModel): void {
    this.task.set(task);
    this.step.set(step);
    this.state.set(state);
  }

  public previous(): void {
    this.previousClicked.emit();
  }

  public next(): void {
    this.nextClicked.emit();
  }

  public close(): void {
    this.closeClicked.emit();
  }

  public updateTask(updatedTask: TaskStepUpdateDto): void {
    this.taskUpdated.emit(updatedTask);
  }

  public get processing(): boolean {
    return this.processingFlag;
  }

  protected set processing(value: boolean) {
    this.processingFlag = value;
    this.processingUpdated.emit(value);
  }
}
